
// Vue
import {Options, Vue} from "vue-class-component";

// Vendors
import moment from "moment";

// Models
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";

// Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElDatePicker,
} from "element-plus";
import store from "@/store";

@Options({
  props: [
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElDatePicker,
  },
})
export default class CoachPlayersProfileTrainingsFilterIndexVue extends Vue {
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  getTrainingsByFilter(): void {
    this.$emit("getTrainingsByFilter", this.formData);
  }

  created(): void {
    this.formData.filter.user_id = this.$route.params.id;
  }
}
